export default __webpack_public_path__ + "assets/c32a59b8c85168bd5bbd59a2c6026bfa.png";